import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import styles from './styles';

const SelectAutoComplete = (props) => {
  const { id, field, data, updateData, closeCellAfterSelect, type } = props;
  const apiRef = useGridApiContext();
  const classes = styles();
  const [selectedValue, setSelectedValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {
    const initialValue = data.find((option) => option._id === id) || null;
    setSelectedValue(initialValue);
  }, [id, data]);

  const handleChange = (event, newValue) => {
    event.stopPropagation();
    event.preventDefault();
    if (typeof newValue === 'string') {
      const newEntry = (type === 'rig')
        ? { RigName_Number: newValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0 }
        : { LeaseName: newValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0, RigName_Number: '' };
      updateData(id, field, newEntry);
      setSelectedValue(newEntry);
      setInputValue(newValue);
    } else if (newValue) {
      setTimeout(() => {
        updateData(id, field, newValue);
      }, 10);
      setSelectedValue(newValue);
      setInputValue(type === 'rig' ? newValue.RigName_Number : newValue.LeaseName);
    }

    if (closeCellAfterSelect) {
      apiRef.current.setCellMode(id, field, 'view');
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      const newEntry = (type === 'rig')
        ? { RigName_Number: inputValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0 }
        : { LeaseName: inputValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0, RigName_Number: '' };
      updateData(id, field, newEntry);
      setSelectedValue(newEntry);
      if (closeCellAfterSelect) {
        apiRef.current.setCellMode(id, field, 'view');
      }
    }
  };

  const handleBlur = () => {
    const newEntry = (type === 'rig')
      ? { RigName_Number: inputValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0 }
      : { LeaseName: inputValue, WellNumber: '', WellID: '', ENVOperator: '', RigLatitudeWGS84: 0, RigLongitudeWGS84: 0, RigName_Number: '' };
    updateData(id, field, newEntry);
    if (closeCellAfterSelect) {
      apiRef.current.setCellMode(id, field, 'view');
    }
    setSelectedValue(newEntry);
  };

  const sortedData = data.sort((a, b) => {
    if (type === 'rig') {
      return a.RigName_Number.localeCompare(b.RigName_Number);
    } else {
      return a.LeaseName.localeCompare(b.LeaseName);
    }
  });
  return (
    <FormControl
      variant="filled"
      id="controlled-form"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <Autocomplete
        freeSolo
        id="free-solo-2-demo"
        disableClearable
        options={sortedData}
        value={selectedValue}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return type === 'rig'
            ? `${option?.RigName_Number}`
            : `${option?.LeaseName} ${option?.WellNumber}`;
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            label="Select or Enter"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
          />
        )}
      />
    </FormControl>
  );
};

SelectAutoComplete.propTypes = {
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  data: PropTypes.array.isRequired,
  updateData: PropTypes.func.isRequired,
  closeCellAfterSelect: PropTypes.bool,
  type: PropTypes.string,
};

export default SelectAutoComplete;
